/* ============================================================
   Volare: idle prefetch — the "in-between" loading strategy.

   During the initial page load, only the first gallery slide loads eagerly
   (it's the LCP) and everything else stays lazy/deferred so the visible page
   wins the bandwidth race. THEN, once the page has fully loaded and the
   browser is idle, this script quietly warms up:

   1. the remaining product-gallery images (so clicking a thumbnail swaps
      instantly instead of fetching on first click)
   2. the deferred marketing videos (data-vl-autoplay / preload="none") —
      buffered in the background WITHOUT playing, so they start instantly
      when scrolled to (vl-video-autoplay.js still controls playback)

   Net effect: fast first paint AND instant interactions afterwards.
   ============================================================ */
(function () {
  function warm() {
    /* 1. finish loading every lazy image in the product gallery + thumbnails */
    document
      .querySelectorAll('.product__media-list img[loading="lazy"], .thumbnail-list img[loading="lazy"]')
      .forEach(function (img) {
        img.loading = 'eager'; // flipping the attribute starts the fetch, even in hidden slides
      });

    /* 2. warm the deferred videos with METADATA ONLY (headers + first frames,
       ~100 KB each) — never full files. Full downloads here were pulling 25+ MB
       on phones and starving the gallery images. Scroll-triggered playback
       streams the rest on demand, which starts near-instantly after metadata. */
    document.querySelectorAll('video[data-vl-autoplay]').forEach(function (v) {
      /* BUGFIX: never touch a video that's already playing — load() ABORTS
         playback and left scrolled-to videos frozen on their first frame
         (nothing re-triggered play). Skip active ones entirely; they're
         streaming already, which is all the warm-up wanted anyway. */
      if (!v.paused) return;
      if (v.preload === 'none') {
        v.preload = 'metadata';
        try { v.load(); } catch (e) {}
      }
    });
  }

  function schedule() {
    /* wait for true idle so we never compete with anything still rendering */
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 3000 });
    } else {
      setTimeout(warm, 1500);
    }
  }

  if (document.readyState === 'complete') {
    schedule();
  } else {
    window.addEventListener('load', schedule);
  }
})();
